import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import Auth from './authentication'
import Scenarios from './scenario'
import Games from './game'
import Assets from './assets'
import Locations from './location'
import Proposals from './proposal'
import Organisations from './organisation'
import Logs from './log'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth,
    Scenarios,
    Games,
    Assets,
    Locations,
    Proposals,
    Organisations,
    Logs
  }
})
